/**
 * brokerSummary模块接口列表
 */
import $http from "../utils/http"; // 导入http中创建的axios实例

const brokerSummary = {
  //添加
  createBrokerSummary(params) {
    return $http.post(
      `${global.API_URL}/sme/brokerSummary/createBrokerSummary`,
      params
    );
  },
  //分页
  pageBrokerSummary(params) {
    return $http.post(`${global.API_URL}/sme/bucket/page`, params);
  },
  brokerSummaryPage(params) {
    return $http.post(`${global.API_URL}/sme/brokerSummary/page`, params);
  },
  //详情
  queryBrokerSummaryById(params) {
    return $http.post(
      `${global.API_URL}/sme/brokerSummary/queryBrokerSummaryById`,
      params
    );
  },

  //查询MQ
  queryBrokerByAccountId(params) {
    return $http.post(
      `${global.API_URL}/sme/brokerSummary/queryBrokerByAccountId`,
      params
    );
  },
  //删除
  deleteBrokerSummary(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/brokerSummary/delete`, param);
  },

  // 新增接口
  // 队列
  // 应用系统/应用配置/分页列表
  queryQueueByApplicationId(params) {
    return $http.post(
      `${global.API_URL}/sme/brokerSummary/queryQueueByApplicationId`,
      params
    );
  },
  // 应用系统/应用配置/添加实例/查询
  queryQueueByGroup(params) {
    return $http.post(
      `${global.API_URL}/sme/brokerSummary/queryQueueByGroup`,
      params
    );
  },
  // 应用系统/应用配置/添加实例/添加
  createByapplicationQueueRelation(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationQueueRelation/create`,
      params
    );
  },
  // 应用系统/应用配置/配置阈值查询
  selectWeightByApplicationIdAndQueueId(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationQueueRelation/selectWeightByApplicationIdAndQueueId`,
      params
    );
  },

  // 应用系统/应用配置/配置阈值创建或更新
  updateQueueWeight(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationQueueRelation/updateQueueWeight`,
      params
    );
  },
  // 应用系统/应用配置/删除按钮
  deleteByApplicationIdAndInstanceId(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationQueueRelation/deleteByApplicationIdAndInstanceId`,
      params
    );
  },
  // 应用系统/应用配置/详情按钮
  checkApplicationDataPointStatistics(params) {
    return $http.post(
      `${global.API_URL}/sme/aiForecastDataPoint/checkApplicationDataPointStatistics`,
      params
    );
  },

  // 磁盘
  // 应用系统/应用配置/分页列表
  queryDisksByApplicationId(params) {
    return $http.post(
      `${global.API_URL}/sme/volume/queryDisksByApplicationId`,
      params
    );
  },

  // 应用系统/应用配置/添加磁盘实例/查询
  queryDisksByGroup(params) {
    return $http.post(`${global.API_URL}/sme/volume/queryDisksByGroup`, params);
  },

  // 应用系统/应用配置/添加磁盘实例/添加
  createByapplicationDiskRelation(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationDiskRelation/create`,
      params
    );
  },

  // 应用系统/应用配置/配置阈值查询
  selectWeightByApplicationIdAndDiskId(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationDiskRelation/selectWeightByApplicationIdAndDiskId`,
      params
    );
  },

  // 应用系统/应用配置/配置阈值创建或更新
  updateDiskWeight(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationDiskRelation/updateDiskWeight`,
      params
    );
  },

  // 应用系统/应用配置/删除按钮
  deleteByApplicationIdAndDiskId(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationDiskRelation/deleteByApplicationIdAndDiskId`,
      params
    );
  },

  // ElasticSearch
  // 应用系统/应用配置/分页列表
  queryElasticSearchByApplicationId(params) {
    return $http.post(
      `${global.API_URL}/sme/elasticsearch/queryElasticSearchByApplicationId`,
      params
    );
  },

  // 应用系统/应用配置/添加ES实例/查询
  queryElasticSearchByGroup(params) {
    return $http.post(
      `${global.API_URL}/sme/elasticsearch/queryElasticSearchByGroup`,
      params
    );
  },

  // 应用系统/应用配置/添加ES实例/添加
  createByapplicationEsRelation(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationEsRelation/create`,
      params
    );
  },

  // 应用系统/应用配置/配置阈值查询
  selectWeightByApplicationIdAndEsId(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationEsRelation/selectWeightByApplicationIdAndEsId`,
      params
    );
  },

  // 应用系统/应用配置/配置阈值创建或更新
  updateEsWeight(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationEsRelation/updateEsWeight`,
      params
    );
  },

  // 应用系统/应用配置/删除按钮
  deleteByApplicationIdAndEsId(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationEsRelation/deleteByApplicationIdAndEsId`,
      params
    );
  }
};

export default brokerSummary;



// WEBPACK FOOTER //
// ./src/api/brokerSummary.js